import {throttle} from 'throttle-debounce';

const header = document.querySelector('.j-header');
const wrapper = document.querySelector('.j-wrapper');
const headerHeight = header.offsetHeight;
const events = ['scroll', 'resize', 'onorientationchange'];

const appHeader = () => {
    if (wrapper) {
        const isMoreDelta = window.scrollY > 400;

        const headerModifyMethod = isMoreDelta ? 'add' : 'remove';
        const wrapperPadding = isMoreDelta ? `${headerHeight}px` : '0';

        header.classList[headerModifyMethod]('is-fixed');
        if (header.classList.contains('is-fixed') && header.classList.contains('header_position_static')) {
            wrapper.style.paddingTop = wrapperPadding;
        } else {
            wrapper.style.paddingTop = 0;
        }
    }
};

appHeader();

events.forEach((event) => {
    window.addEventListener(event, throttle(50, appHeader));
});
